import React from "react";
import PhotonLogo from "../Common/PhotonLogo";
import { PanelLeftClose } from "lucide-react";

const SidebarDrawerHeader = ({ onNotebookClick }) => {
  return (
    <div className="flex items-center justify-between px-3 py-3">
      <PhotonLogo className="h-8 w-8 mr-1" />
      <div className="sm:p-[2px] ml-1">
        <div
          role="button"
          tabIndex={0}
          aria-label="Close sidebar"
          className="photon-rail-control h-8 w-8 flex justify-center items-center rounded-lg transition-colors duration-200 cursor-pointer"
          onClick={onNotebookClick}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onNotebookClick();
            }
          }}
        >
          <PanelLeftClose size={20} className="text-ink-gray-500 dark:text-ink-gray-400" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
};

export default SidebarDrawerHeader;
